import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getFullUser } from '../../selectors';

class AdminRoute extends React.Component {
    renderContent(p) {
        if(!this.props.user){
            return '';
        }

        switch(this.props.user.roleId){
            case null:
                return '';
            case 2:
            case 3:
                return <this.props.component {...p}/>;
            default:
                return <Redirect to={{ pathname: '/dashboard', state: { from: p.location } }} />;
        }
    }

    render(){
        return (
            <Route exact={this.props.exact} path={this.props.path} render={props => (
                this.renderContent(props)
            )}/>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: getFullUser(state)
    }
}

// TODO: Need to remove withRouter. Instead I should be passing the location as props down to the child component
// https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md
export default withRouter(connect(mapStateToProps)(AdminRoute));


// WEBPACK FOOTER //
// ./src/components/Admin/AdminRoute.js